import _ from 'lodash';

export const isEmptyRecurse = (obj: any): boolean => {
  return _.isEmpty(obj) || (_.isObject(obj) && _.every(_.values(obj), isEmptyRecurse));
};
